<template>
  <div class="d-flex justify-content-between mt-3">
    <b-button
      v-if="showBackButton && visibilidadeBotao"
      variant="secondary"
      class="me-1"
      @click="$emit('back')"
      :disabled="backDisabled"
      :data-tooltip="backTooltip"
      :data-tooltip-location="tooltipLocation"
    >
      <i class="mdi mdi-arrow-left-circle font-size-15"></i>
    </b-button>
    <div v-else-if="!showBackButton"></div>

    <b-button
      v-if="showNextButton && visibilidadeBotao"
      variant="primary"
      class="ms-1"
      @click="$emit('next')"
      :disabled="nextDisabled"
      :data-tooltip="nextTooltip"
      :data-tooltip-location="tooltipLocation"
    >
      <i class="mdi mdi-arrow-right-circle font-size-15"></i>
    </b-button>
    <div v-else-if="!showNextButton"></div>
  </div>
</template>

<script>
export default {
  name: "ClienteRuralTabNavigation",
  props: {
    showBackButton: {
      type: Boolean,
      default: false
    },
    showNextButton: {
      type: Boolean,
      default: false
    },
    backDisabled: {
      type: Boolean,
      default: false
    },
    nextDisabled: {
      type: Boolean,
      default: false
    },
    backTooltip: {
      type: String,
      default: "Voltar"
    },
    nextTooltip: {
      type: String,
      default: "Avançar"
    },
    tooltipLocation: {
      type: String,
      default: "left"
    },
    visibilidadeBotao: {
      type: Boolean,
      default: true
    }
  }
};
</script>
